import { render, staticRenderFns } from "./BillingListItem.yaml?vue&type=template&id=20f83dc8&component"
import script from "./BillingListItem.yaml?vue&type=script&lang=ts&component"
export * from "./BillingListItem.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports